import { Injectable } from '@angular/core';
import { Leaflet } from '../leaflet-export';

@Injectable()
export class LeafletTimeBarService {
  extends() {
    /**
     * CONTROL PLUG-IN
     */
    Leaflet.Control.WaterTimeBarControl = Leaflet.Control.extend({
      includes: Leaflet.Evented ? Leaflet.Evented.prototype : Leaflet.Mixin.Events,

      options: {
        container: null,
        position: 'bottomright',
      },

      onAdd: function (map) {
        const container =
          typeof this.options.container === 'string'
            ? Leaflet.DomUtil.get(this.options.container)
            : this.options.container;

        return container;
      },

      onRemove: function (map) {},
    });

    Leaflet.control.waterTimeBarControl = function (opts) {
      return new Leaflet.Control.WaterTimeBarControl(opts);
    };

    /**
     * PLUG-IN
     */

    Leaflet.WaterTimeBar = (Leaflet.Layer || Leaflet.Class).extend({
      includes: Leaflet.Evented || Leaflet.Mixin.Events,

      initialize: function (waterTimeBarOptions) {
        Leaflet.setOptions(this, waterTimeBarOptions);
        this.setDataRange(waterTimeBarOptions.dataRange);
      },

      getDataRange() {
        return this._dataRange;
      },
      setDataRange(dataRange) {
        this._dataRange = dataRange;

        if (this._dataRange?.steps?.length > 0) {
          this.setCurrentStep(this._dataRange.steps[0]);
        }
      },
      getCurrentStep() {
        return this._currentStep;
      },
      setCurrentStep(value) {
        this._currentStep = value;
        this.fire('currentStepChange', {
          step: this._currentStep,
        });
      },
    });

    Leaflet.waterTimeBar = function (opts) {
      return new Leaflet.WaterTimeBar(opts);
    };

    Leaflet.Map.addInitHook(function () {
      if (this.options.waterTimeBarOptions) {
        this.waterTimeBar = Leaflet.waterTimeBar(this.options.waterTimeBarOptions || {});
      }
    });
  }
}
